<template>
    <div id="app">
        <lang-box class="lang-container" />
        <div class="nav" v-if="$route.path !== '/'">
            <LeftBar :alpha="alpha" />
        </div>
        <router-view></router-view>
        <Footer />
    </div>
</template>

<script>
import Footer from './components/Footer.vue'
import LeftBar from '@/components/LeftBar.vue'
export default {
    name: 'App',
    components: { Footer, LeftBar },
    data() {
        return {
            alpha: 0.99
        }
    },
    mounted() {
        if (window.innerWidth < 769) {
            this.alpha = 1
        }
        window.addEventListener('resize', this.updateScreenWidth)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenWidth)
    },
    methods: {
        updateScreenWidth() {
            if (this.$route.path === '/') return
            if (window.innerWidth < 769) {
                this.alpha = 1
            } else {
                this.alpha = 0.99
            }
        }
    }
}
</script>
<style lang="less" scoped>
.nav {
    position: fixed;
    left: 0;
    top: 0;
    background: rgb(46, 85, 165);
    z-index: 10;
}
.lang-container {
    position: absolute;
    right: 25px;
    top: 15px;
    z-index: 310;
}
@media screen and (max-width: 768px) {
    .lang-container {
        display: none;
    }
    .nav {
        background: transparent;
    }
}
</style>
